import { CtaLink, Heading, Paragraph } from '@purpurds/purpur';
import { TeliaGrid } from '@teliads/components/react';

import ContentBlocksWrapper from 'components/custom/content-block/ContentBlocksWrapper';

const RichtextWithSideSection = ({ component }: any) => {
  return (
    <div key={component.richtextContainerId} style={{ padding: '32px 0' }}>
      <TeliaGrid key={component.richtextContainerId}>
        <div
          className={`assembly-flexible-page__richtext-duplex ${
            component.reverseOrder ? 'assembly-flexible-page__richtext-duplex--reverse' : ''
          }`}
        >
          <div className="assembly-flexible-page__richtext-duplex__text-content">
            {component.sideSection.title && (
              <Heading tag="h4" variant="title-300">
                {component.sideSection.title}
              </Heading>
            )}
            {component.sideSection.preamble && (
              <Paragraph>{component.sideSection.preamble}</Paragraph>
            )}
            {component.sideSection.cta && (
              <div>
                <CtaLink href={component.sideSection.cta.url} variant="primary">
                  {component.sideSection.cta.text}
                </CtaLink>
              </div>
            )}
          </div>
          <div className="assembly-flexible-page__richtext-duplex__content-block-wrapper">
            <ContentBlocksWrapper
              contentBlocks={component.body.content}
              assetLinks={component.body.links}
              disableAnchorTabs
              isFullWidth
            />
          </div>
        </div>
      </TeliaGrid>
    </div>
  );
};

export default RichtextWithSideSection;
